import dayjs from 'dayjs';
import { authedAxios } from '@shared/axios';
import { downloadResponse } from '@shared/services/download.service';
import type { DateRange } from '@shared/models/dateRange';

export const formatDateRangeForQuery = (range: DateRange) => {
  const startDate = dayjs(range.start).format('MM/DD/YYYY');
  const endDate = dayjs(range.end).format('MM/DD/YYYY');
  return {
    startDate,
    endDate,
  };
};

export const downloadOrderReport = async (range: DateRange) => {
  const response = await authedAxios.post(`/api/admin/reports/orders`, null, {
    params: formatDateRangeForQuery(range),
    responseType: 'blob',
  });
  return downloadResponse(response);
};

export const downloadTaxesReport = async (range: DateRange) => {
  const response = await authedAxios.post(`/api/admin/reports/taxes`, null, {
    params: formatDateRangeForQuery(range),
    responseType: 'blob',
  });
  return downloadResponse(response);
};

export const downloadStudioRevenueReport = async (range: DateRange) => {
  const response = await authedAxios.post(`/api/admin/reports/revenue`, null, {
    params: formatDateRangeForQuery(range),
    responseType: 'blob',
  });
  return downloadResponse(response);
};

export const downloadCommissionsReport = async (range: DateRange) => {
  const response = await authedAxios.post(`/api/admin/reports/commissions`, null, {
    params: formatDateRangeForQuery(range),
    responseType: 'blob',
  });
  return downloadResponse(response);
};

export const downloadRevenueReport = async (range: DateRange) => {
  const response = await authedAxios.post(`/api/admin/reports/revenue`, null, {
    params: formatDateRangeForQuery(range),
    responseType: 'blob',
  });
  return downloadResponse(response);
};

export const downloadRefundReport = async (range: DateRange) => {
  const response = await authedAxios.post(`/api/admin/reports/refunds`, null, {
    params: formatDateRangeForQuery(range),
    responseType: 'blob',
  });
  return downloadResponse(response);
};
